import * as Yup from "yup"

const NewStepValidation = {
    stepName: Yup.string().required('Il campo è obbligatorio'),
    stepType: Yup.string().required('Il campo è obbligatorio'),
    // stepAssignTo: Yup.string().required('Il campo è obbligatorio'),
    stepOrder: Yup.number()
        .moreThan(0, "Il valore inserito deve essere maggiore di 0")
        .transform((v, o) => o === '' ? null : v)
        .required('Il campo è obbligatorio'),
    stepDeadline: Yup.number()
        .moreThan(-1)
        .transform((v, o) => o === '' ? null : v)
        .required('Il campo è obbligatorio')
}

export default Yup.object()
    .shape(
        NewStepValidation,
    )
    .required()
